/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useParentContextHydration = ({
  ability,
  setters: {
    setFilters,
    setAppliedFilters,
    setSearch,
    setPage,
    setItemsPerPage,
    setSortBy,
    setSortOrder,
    setApplyFilters,
  },
  defaultSortBy = "",
  defaultSortOrder = "desc",
  permissionResolver,
  legacyHandler,
  dependencies = []
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Hydration precedence: full parent context wins over single-id legacy state
    if (location?.state?.parentContext) {
      const parentCtx = location.state.parentContext;
      setFilters(parentCtx.filters || {});
      setAppliedFilters(parentCtx.appliedFilters || {});
      setSearch(parentCtx.search || "");
      setPage(parentCtx.page || 1);
      setItemsPerPage(parentCtx.itemsPerPage || 25);
      setSortBy(parentCtx.sortBy || defaultSortBy);
      setSortOrder(parentCtx.sortOrder || defaultSortOrder);
      
      if (permissionResolver) {
        permissionResolver(parentCtx, ability);
      }
      
      setApplyFilters(true);
      navigate(location.pathname, { replace: true, state: {} });
    } else if (legacyHandler) {
      legacyHandler(ability);
    }
  }, [ability, location, navigate, ...dependencies]);
};
